export const environment = {
  api_url: 'https://$customer_subdomain$.3.stage.businesscenter.tangoe.com/store/api/v1'
};
